module.exports = __webpack_public_path__ + "img/logo-new.d031f3fc.png";